import { Box, Typography } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';

export default function AdminGridEmpty({
  title = 'No data found',
  subtitle = 'Nothing matches this view yet',
}: {
  title?: string;
  subtitle?: string;
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        height: '100%',
        minHeight: 220,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 4,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: '14px',
          bgcolor: 'action.hover',
          display: 'grid',
          placeItems: 'center',
          mb: 1.5,
          color: 'text.disabled',
        }}
      >
        <InboxOutlined fontSize="medium" />
      </Box>
      <Typography variant="subtitle1" fontWeight={700} color="text.secondary">
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5, maxWidth: 360 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
